/* ============
 * Mutation types for the followUps module
 * ============
 *
 * The mutation types that are available
 * on the followUps module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({

  CREATE_FOLLOW_UP: null,
  CREATE_FOLLOW_UP_SUCCESS: null,
  CREATE_FOLLOW_UP_FAIL: null,

  UPDATE_FOLLOW_UP: null,
  UPDATE_FOLLOW_UP_SUCCESS: null,
  UPDATE_FOLLOW_UP_FAIL: null,

  FETCH_FOLLOW_UP_LIST: null,
  FETCH_FOLLOW_UP_LIST_SUCCESS: null,
  FETCH_FOLLOW_UP_LIST_FAIL: null,

  DELETE_FOLLOW_UP: null,
  DELETE_FOLLOW_UP_SUCCESS: null,
  DELETE_FOLLOW_UP_FAIL: null,

  GET_FOLLOW_UP_SYMPTOMS: null,
  GET_FOLLOW_UP_SYMPTOMS_SUCCESS: null,
  GET_FOLLOW_UP_SYMPTOMS_FAIL: null,

  RESOLVE_FOLLOW_UP_ALERT: null,
  RESOLVE_FOLLOW_UP_ALERT_SUCCESS: null,
  RESOLVE_FOLLOW_UP_ALERT_FAIL: null,

  FETCH_RESOLVED_NOTES: null,
  FETCH_RESOLVED_NOTES_SUCCESS: null,
  FETCH_RESOLVED_NOTES_FAIL: null

});
